<template>
  <div>
    <h4 class="card-title mb-3">
      Vendor Product Report Summary
    </h4>
    <div class="input-group mb-4 d-flex flex-row p2">
      <label style="margin-right: 10px">Vendor: </label>
      <div class="form-outline ">
        <select class="form-control" style="width: 300px"  :value="selectedVendor" @change="handleChange">
          <option
            v-for="(vendor, index) in vendors"
            :key="index"
            :value="vendor.id"
            >{{ vendor.name }}</option
          >
        </select>
      </div>
      <button class="btn btn-primary" @click="onfilter">
        Filter
      </button>
    </div>
    <br />

    <div class="row">
      <div class="col-6">
        <label><b>Date From</b></label>
        <input type="date" class="form-control":value="dateFrom" @change="handleDateChange($event, 1)" />
      </div>
      <div class="col-6">
        <label><b>Date To</b></label>
        <input type="date" class="form-control":value="dateTo" @change="handleDateChange($event, 2)" />
      </div>
    </div>

    <br />

    <div class="text-left">
      {{
        dateFromFormatted != null && dateToFormatted != null
          ? `Reported Date from ${dateFromFormatted} to ${dateToFormatted}`
          : ""
      }}
    </div>

    <div class="text-right">
      <button
        class="btn btn-rounded btn-primary mr-2"
        style="width: 150px;"
        @click="filterSearchProduct()"
      >
        Filter
      </button>
      <button
        class="btn btn-rounded btn-primary"
        style="width: 150px;"
        @click="resetFilter(4)"
      >
        Reset
      </button>
    </div>
    <div class="table-responsive">
      <table
        id="vendor_product_summary_table"
        class="display table table-striped table-bordered report-table"
        style="width:100%; text-align: center;"
      >
        <thead>
          <tr>
            <th>No.</th>
            <th>Vendor Name</th>
            <th>Product Name</th>
            <th>Points Redeemed</th>
            <th>Points Redeemed in B$</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(vendor, index) in vendorProducts" :key="index">
            <td>{{ index + 1 }}</td>
            <td>{{ vendor.vendor_name }}</td>
            <td>{{ vendor.product_name }}</td>
            <td>{{ vendor.points_redeemed }}</td>
            <td>{{ vendor.total_price }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    selectedVendor: {
      required: true,
    },

    vendors: {
      type: Array,
      required: true,
    },

    onfilter: {
      type: Function,
      required: true,
    },

    dateFrom: {
      type: String,
      required: false,
      default: null
    },

    dateTo: {
      type: String,
      required: false,
      default: null
    },

    dateFromFormatted: {
      type: String,
      required: false,
      default: null
    },

    dateToFormatted: {
      type: String,
      required: false,
      default: null
    },

    filterSearchProduct: {
      type: Function,
      required: true,
    },

    resetFilter: {
      type: Function,
      required: true,
    },

    vendorProducts: {
      type: Array,
      required: true,
    },
  },

  methods: {
    handleChange(event) {
      const newValue = event.target.value;
      this.$emit('onVendorProductSelected', newValue);
    },

    handleDateChange(event, type) {
      const newValue = event.target.value;
      this.$emit('onChangeDate', newValue, type);
    },
  }
}
</script>
